import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BannerSection from "../component/section/banner";

import { setAuth } from "../redux/features/authSlice";
import { useDispatch } from "react-redux";
import matrimonyInstance from "../utils/axios";
import { LOGIN, FORGET_PASSWORD, RESET_PASSWORD } from "../API_LIST";
import { jwtDecode } from "jwt-decode";
import ROLES from "../utils/constants";
import { getDataFromJwt, toastMaker, validateEmail } from "../utils/utility";
import LoaderComponent from "../component/loader/LoaderComponent";

const LoginPage = () => {
	const navigate = useNavigate();
	const [userData, setUserData] = useState({ email: "", password: "" });
	const [isVisiblePassword, setIsVisiblePassword] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleChange = (e) => {
		setUserData((prev) => {
			return { ...prev, [e.target.name]: e.target.value };
		});
	};
	const disPatch = useDispatch();

	const loginUser = async (e) => {
		e.preventDefault();

		let data = userData;
		setLoading(true);
		matrimonyInstance
			.post(LOGIN, data)
			.then((response) => {
				if (response.data) {
					setLoading(false);
					const decoded = jwtDecode(response?.data?.token);
					disPatch(setAuth(decoded));
					localStorage.setItem("jwtToken", `Bearer ${response?.data?.token}`);
					let landingUrl = ROLES[decoded.role].landingUrl;
					navigate(landingUrl);
				}
			})
			.catch((error) => {
				// if (error.status === 400) {
				//   return toastMaker("Enter email & password", "error");
				// }
				// if (error.status === 404) {
				//   return toastMaker("User not found", "error");
				// }
				if (error?.response?.data?.error) {
					if (error.status === 400) {
						setLoading(false);
						return toastMaker(error, "Error");
					} else {
						setLoading(false);
						return toastMaker(error?.response?.data?.error, "error");
					}
				} else {
					setLoading(false);
					return toastMaker("Something went wrong", "error");
				}
			});
	};

	const handleForgotPassword = async (e) => {
		if (e && e.preventDefault) {
			e.preventDefault();
		}
		const email = userData.email;
		let isEmail = validateEmail(userData.email);
		if (!email || !isEmail) {
			toastMaker("Please enter valid email address", "error");
			return;
		}
		try {
			await matrimonyInstance.post(
				FORGET_PASSWORD,
				{ email },
				setLoading(true),
			);
			setLoading(false);
			toastMaker("Reset Password Email Sent", "success");
		} catch (error) {
			if (error.response) {
				setLoading(false);
				toastMaker(error.response.data.message, "error");
			} else {
				setLoading(false);
				toastMaker("Something went wrong", "error");
			}
		}
	};

	useEffect(() => {
		if (localStorage.getItem("jwtToken")) {
			const roleid = getDataFromJwt("role");
			navigate(ROLES[roleid].landingUrl);
		}
	}, []);

	return (
		<React.Fragment>
			{/* <BannerSection /> */}
			<div className="container">
				{loading && <LoaderComponent />}
				<div className="login-section padding-tb">
					<div className="row align-items-center">
						<div className="account-container">
							<div className="d-flex gap-5">
								<h3
									className="account-title cursor-pointer"
									onClick={() => navigate("/login")}
								>
									Member Login
								</h3>
								{/* <h3
                  className="account-title cursor-pointer"
                  onClick={() => navigate("/volunteer-login")}
                >
                  Volunteer Login
                </h3> */}
							</div>
							<div className="row justify-content-between">
								<div className="col-12 col-lg-7 col-sm-12">
									<div className="account-wrapper">
										<div className="account-form">
											<div className="form-title">
												<p className="mb-10">
													If you are already a Registered member, enter the
													details below.
												</p>
											</div>
											<form onSubmit={loginUser}>
												<div className="row mt-20 justify-content-center">
													<div className="col-lg-12 col-sm-12 col-12 px-3">
														<div className="form-group">
															<div className="input-title">
																Profile Id / Email Id
															</div>
															<div className="input-field position-relative">
																<input
																	type="email"
																	id="item01"
																	placeholder="Email"
																	className="input-icon"
																	name="email"
																	value={userData.email}
																	onChange={handleChange}
																	maxLength={40}
																/>
																<div className="login-icon">
																	<img
																		src="./assets/images/bat-img/login-email.svg"
																		alt="email icon"
																	/>
																</div>
															</div>
														</div>
													</div>
													<div className="col-lg-12 col-sm-12 col-12 px-3">
														<div className="form-group">
															<div className="input-title">Password</div>
															<div className="input-field position-relative">
																<input
																	id="item07"
																	placeholder="Enter your password"
																	className="with-icon input-icon"
																	type={isVisiblePassword ? "text" : "password"}
																	name="password"
																	maxLength={20}
																	value={userData.password}
																	onChange={handleChange}
																/>
																<div className="login-icon">
																	<img
																		src="./assets/images/bat-img/login-password.svg"
																		alt="password icon"
																	/>
																</div>
																<div
																	className="password-visible-icon"
																	onClick={() =>
																		setIsVisiblePassword(!isVisiblePassword)
																	}
																>
																	{isVisiblePassword ? (
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			fill="none"
																			viewBox="0 0 24 24"
																			strokeWidth={1.5}
																			stroke="currentColor"
																			className="size-6"
																		>
																			<path
																				strokeLinecap="round"
																				strokeLinejoin="round"
																				d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
																			/>
																			<path
																				strokeLinecap="round"
																				strokeLinejoin="round"
																				d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
																			/>
																		</svg>
																	) : (
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			fill="none"
																			viewBox="0 0 24 24"
																			strokeWidth={1.5}
																			stroke="currentColor"
																			className="size-6"
																		>
																			<path
																				strokeLinecap="round"
																				strokeLinejoin="round"
																				d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
																			/>
																		</svg>
																	)}
																</div>
															</div>
														</div>
													</div>
													<div className="forgot-password-content">
														<Link
															to="#"
															onClick={(e) => {
																e.preventDefault();
																handleForgotPassword();
															}}
														>
															Forgot your Password?
														</Link>
														<button
															className="button login-btn text-white"
															onClick={loginUser}
															type="submit"
														>
															LOGIN
														</button>
													</div>
												</div>
											</form>
										</div>
										<div className="account-bottom1  text-center">
											<p className="cate pt-10">Don't have an account?</p>
											<button className="button login-btn create-btn text-white">
												<Link to="/register">Create an account</Link>
											</button>
										</div>
										<p className="cate pt-10">
											If you are not a BAT member, please get membership. BAT
											Memberships offer free matrimony services exclusively for
											member's own children. If you want BAT membership please{" "}
											<Link to="/join-bat">click here.</Link>
										</p>
									</div>
								</div>
								<div className="col-12 col-lg-5 col-sm-12">
									<div className="right-image-container">
										<img
											src="./assets/images/bat-img/login-img.svg"
											alt="login image"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default LoginPage;
